module.exports = __webpack_public_path__ + "static/media/cat-lg-6.fed805c5.jpg";